import axios, { AxiosInstance, AxiosResponse } from "axios";
import { ContactSubmission } from "../models/contact/IContactSubmission";

const createInstance = (): AxiosInstance => {
  const headers = {};
  return axios.create({
    baseURL: process.env.NEXT_PUBLIC_ENROLLMENT_API,
    headers
  });
};

export const postEnquiry = async (
  data: ContactSubmission
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<AxiosResponse<any>> => createInstance().post(`/enquiry`, data);
